import { render } from "./ControlsBar.vue?vue&type=template&id=95a70ebc"
import script from "./ControlsBar.vue?vue&type=script&lang=js"
export * from "./ControlsBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__